const BASE = '';

const modalidadeQuery = modalidade => modalidade === 'embalagem' ? '' : `?modalidade=${encodeURIComponent(modalidade)}`;

function authHeaders(extra = {}) {
  const token = localStorage.getItem('token');
  return { Authorization: `Bearer ${token}`, ...extra };
}

async function handleResponse(res) {
  if (!res.ok) {
    let detail = `Erro ${res.status}`;
    try {
      const j = await res.json();
      if (j.detail) detail = typeof j.detail === 'string' ? j.detail : JSON.stringify(j.detail);
    } catch (_) {}
    throw new Error(detail);
  }
  return res.json();
}

export async function uploadExcel(file) {
  const fd = new FormData();
  fd.append('file', file);
  const res = await fetch(`${BASE}/api/paletizacao/upload`, {
    method: 'POST',
    headers: authHeaders(),
    body: fd,
  });
  return handleResponse(res);
}

export async function getJob(jobId) {
  const res = await fetch(`${BASE}/api/paletizacao/jobs/${jobId}`, {
    headers: authHeaders(),
  });
  return handleResponse(res);
}

export async function calcularPlano(volumeId, modalidade = 'embalagem') {
  const res = await fetch(`${BASE}/api/paletizacao/volumes/${volumeId}/calcular${modalidadeQuery(modalidade)}`, {
    method: 'POST',
    headers: authHeaders(),
  });
  return handleResponse(res);
}

export async function salvarPlano(volumeId, planoEdit, modalidade = 'embalagem') {
  const res = await fetch(`${BASE}/api/paletizacao/volumes/${volumeId}/plano${modalidadeQuery(modalidade)}`, {
    method: 'POST',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(planoEdit),
  });
  return handleResponse(res);
}

// POC temporário (jul/2026) — codigo_81 manual do lote; substituir por vínculo ao produto cadastrado no futuro
export async function gerarPdf(volumeId, imagens, codigo_81 = null, modalidade = 'embalagem') {
  const res = await fetch(`${BASE}/api/paletizacao/volumes/${volumeId}/gerar-pdf${modalidadeQuery(modalidade)}`, {
    method: 'POST',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({ imagens, codigo_81 }),
  });
  if (!res.ok) {
    let detail = `Erro ${res.status}`;
    try {
      const j = await res.json();
      if (j.detail) detail = typeof j.detail === 'string' ? j.detail : JSON.stringify(j.detail);
    } catch (_) {}
    throw new Error(detail);
  }
  return res.blob();
}
